<template>
  <div class="subtitle-timeline" :style="{width: totalWidth + 'px'}" v-drag>
    <div class="total-time-width" data-action="ruler" :style="{width: totalTime * secondWidth + 'px'}">
      <div
        class="scenes-time-line"
        v-for="(s,j) in scenesTime"
        :key="j"
        :style="{left: secondWidth*s + 'px'}"
      >
      </div>
      <div 
        v-show="!isPlay && showAddBtn" 
        class="add-btn" 
        @click="addSubtitle"
        :style="{left: secondWidth*nowTime + 'px'}"
      >
        <i></i>
        <span>添加字幕</span>
      </div>
    </div>
    <div
      class="drag-box-content"
      :class="{active: i===subIndex}"
      v-for="(s, i) in simple"
      :key="s.start+s.text"
      :style="{
        left:secondWidth*s.start + 'px',
        width: secondWidth*s.dura + 'px'
      }"
    >
      <div class="drag-left" data-action="left" :data-index="i"></div>
      <div class="drag-right" data-action="right" :data-index="i"></div>
      <div class="drag-move" data-action="move" :data-index="i">{{s.text}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import timelineMixins from './timelineMixins'

export default {
  name: 'subtitleTimeline',
  mixins: [timelineMixins],
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      subIndex: "subtitle/subIndex", // 选中的字幕数组的index
      subtitleArr: "subtitle/subtitles", // 字幕数组
      dubbingArr: "addSoundtrack/getDubbingArr"
    })
  },
  mounted() {
    this.$bus.on("subtitle_keycode_del", () => {
      this.calcSubtitles()
      this.checkAdd()
    })
    this.$bus.on("subtitle_panel_del", () => {
      this.calcSubtitles()
      this.checkAdd()
    })
    this.$bus.on("subtitle_undoRodo_execute", ({mod, type}) => {
      if(mod === "updateSubtitle_time" ||
         mod === "addSubtitles_time" ||
         mod === "swapSubtitles_time" ||
         mod === "delSubtitles") {
        this.calcSubtitles()
        if(this.subIndex > -1) {
          this.$emit('changeNowTime', this.simple[this.subIndex].start);
        } else {
          this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.nowTime * 60)})
        }
        this.checkAdd()
      }
    })
    this.$bus.on("pickUpSubtitle", data => {
      let subtitles = [];
      if (data && data.length) {
        let sT = 0;
        let mT = this.totalTime;
        let cT = 0;
        let subs = [];
        let sub = null;
        let str = JSON.stringify(this.subtitleArr);
        this.$store.commit("subtitle/clearSubtitles");
        data.forEach(info => {
          let dubbing = this.dubbingArr[info.index]
          if(info.index < 0 || !dubbing) {
            sT = 0;
            mT = this.totalTime;
            cT = 0;
          } else {
            sT = dubbing.timeSlot[0];
            mT = dubbing.timeSlot[1];
            cT = dubbing.cut[0];
          }
          subs = info.data;
          for(let i in subs) {
            let s = {...subs[i]};
            s.bg = s.bg/1000 - cT;
            s.ed = s.ed/1000 - cT;
            if(s.ed < 0.2) {
              continue;
            }
            if(s.bg < 0) {
              s.bg = 0;
            }
            sub = {
              startTime: s.bg + sT,
              endTime: s.ed + sT,
              text: s.onebest
            }
            if(sub.startTime >= mT) {
              break;
            }
            if(sub.endTime > mT) {
              sub.endTime = mT
            }
            subtitles.push(sub)
          }
        });
        this.$store.commit("subtitle/addGroupSubtitles", {
          subtitles: subtitles
        });
        this.$bus.emit("insert_subtitle_undo", {
          type: "swapSubtitles_time",
          data: {
            reData: str,
            data: JSON.stringify(this.subtitleArr)
          }
        });
        this.calcSubtitles();
        this.checkAdd();
        // 添加完成后是否显示的问题（时间不会跳转）
        this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.nowTime * 60)})
      }
    });
    this.$bus.on("subtitle_updateItemText_vue", () => {
      this.simple[this.subIndex].text = this.subtitleArr[this.subIndex].text
    })
  },
  beforeDestroy() {
    this.$bus.off("subtitle_keycode_del")
    this.$bus.off("subtitle_panel_del")
    this.$bus.off("subtitle_undoRodo_execute")
    this.$bus.off("pickUpSubtitle")
    this.$bus.off("subtitle_updateItemText_vue")
  },
  methods: {
    initData() {
      this.calcSubtitles();
      this.checkAdd();
    },
    calcSubtitles() {
      // 处理数组为简易数组
      let part = null;
      let sub = null;
      this.simple = [];
      for (let i in this.subtitleArr) {
        sub = this.subtitleArr[i];
        part = {
          start: sub.startTime,
          end: sub.endTime
        };
        part.dura = part.end - part.start;
        part.text = sub.text;
        if(part.end > this.totalTime) {
          // 字幕大于时间的时候（删除字幕或者截取）
          let j = +i;
          if(this.totalTime - part.start >= 0.2) {
            part.end = this.totalTime;
            part.dura = part.end - part.start;
            this.$store.commit("subtitle/updateSubtitle", {index: j, subtitle: {
              startTime: part.start,
              endTime: part.end
            }});
            this.simple.push(part);
            j++
          }
          while (this.subtitleArr && this.subtitleArr.length > j) {
            this.$store.commit("subtitle/delSubtitles", j);
          }
          return;
        }
        this.simple.push(part);
      }
    },
    addSubtitle() {
      // 添加字幕
      let index = this.checkAdd(); // 插入的位置
      if(!this.showAddBtn) return;
      let sub = {
        startTime: +this.nowTime.toFixed(3),
        endTime: 0
      }; // 添加字幕的对象
      let limitR = 0; // 字幕的end所存在的范围最值
      
      if(index > -1 && index < this.simple.length) {
        limitR = +this.simple[index].start.toFixed(3);
      } else {
        limitR = this.totalTime;
      }

      if (limitR - sub.startTime > 1) {
        sub.endTime = sub.startTime + 1;
      } else {
        sub.endTime = limitR;
      }

      this.$store.commit("subtitle/addSubtitles", {
        index: index,
        subtitle: sub
      });
      this.calcSubtitles();
      this.setSelectIndex(index);
      this.checkAdd();
      this.$bus.emit("insert_subtitle_undo", {
        type: "addSubtitles_time",
        data: {
          index: index,
          data: JSON.stringify(this.subtitleArr[index])
        }
      });
    },
    setSelectIndex(i) {
      this.settingPanel(i, 'subtitle');
      this.indexS = i;
      if(i > -1) {
        this.$emit('changeNowTime', this.simple[i].start);
      }
      this.$store.commit("subtitle/setSubIndex", i);
      this.$store.commit("addSoundtrack/setMusicIndex", -1);
      this.$store.commit("addSoundtrack/setDubbingIndex", -1);
    },
    changeSelect(){
      let subtitle = {
        startTime: +this.simple[this.indexS].start.toFixed(3),
        endTime: +this.simple[this.indexS].end.toFixed(3) 
      }
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateSubtitle_time",
        data: {
          index: this.indexS,
          reData: {
            startTime: this.subtitleArr[this.indexS].startTime,
            endTime: this.subtitleArr[this.indexS].endTime
          },
          data: subtitle
        }
      });
      this.$store.commit("subtitle/updateSubtitle", { subtitle });
      this.$emit('changeNowTime', this.simple[this.indexS].start);
    }
  }
}
</script>
<style lang="scss" scrope>
@import './timeline.scss';

.subtitle-timeline {
  position: relative;
  left: 10px;
  top: 0;
  height: 24px;
  width: 100px;
  margin-bottom: 5px;
  background-color: #e5e6f0;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/timelineContent/subtitle.vue